import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {

  constructor() { }
  ngOnInit() {
    
  }
  
  highlightText(className) {
    let el = document.querySelectorAll(`div.${className}`)[0];
    el.classList.add('highlight');
  }

  unhighlightText(className) {
    let el = document.querySelectorAll(`div.${className}`)[0];
    el.classList.remove('highlight');
  }

}
